import { __zcFin, __zcFinZ, __zcHop, __zcMkv, __zcPlain, __zcPs } from "__zod-compiler-runtime__";
import * as z from 'zod'

export const VendorPixelTypeSchema = /* @__PURE__ */ (() => {
var __zs=z.enum(['page-view', 'cta-click']);
function __fc_0(input){return (input==="page-view"||input==="cta-click");}
var __rfm_z=__zs.safeParse;
function safeParse_VendorPixelTypeSchema(input){
if(__fc_0(input)){return{success:true,data:input};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_VendorPixelTypeSchema,__zs,__fc_0,__fc_0);
})()
export type VendorPixelType = z.infer<typeof VendorPixelTypeSchema>

/**
 * Schema for a single vendor pixel entry. The BE emits one entry per pixel,
 * carrying either a page-view or a click-event URL.
 *
 * During the BE/FE transition both shapes are accepted:
 * - Legacy fields (`clickEventUrl`, `pageViewUrl`) stay optional until BE drops them.
 * - New canonical fields (`type`, `url`, `targets`) are optional today and will
 *   eventually become required (and `type` discriminated) in a follow-up PR.
 *
 * `targets` (cta-click only) is a list of subset matchers against the click
 * payload parsed from `data-analytics-event`. OR across entries; AND on the
 * `(key, value)` pairs within each entry. Absent / empty array = fire on any
 * analytics-event click in the tracker tree.
 */
export const VendorPixelSchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  key: z.string(),

  // Legacy fields — optional throughout transition; removed once BE flips.
  clickEventUrl: z.string().optional(),
  pageViewUrl: z.string().optional(),

  // New canonical fields — optional during transition; eventually required.
  url: z.string().optional(),
  type: VendorPixelTypeSchema.optional(),
  targets: z.array(z.record(z.string(), z.string())).optional(),
});
var __lh_9=__zcHop;
function __rf_8(o){var __rk_6,__rv_7;for(__rk_6 in o){if(__rk_6==="__proto__")continue;if(__lh_9.call(o,__rk_6)){__rv_7=o[__rk_6];if(!(typeof __rv_7==="string")){return false;}}}return true;}
function __af_10(a){for(var __ae_5,i=0;i<a.length;i++){__ae_5=a[i];if(!(__zcPlain(__ae_5)&&__rf_8(__ae_5))){return false;}}return true;}
function __fc_11(input){var __w_0,__w_1,__w_2,__w_3,__w_4;return typeof input==="object"&&input!==null&&!Array.isArray(input)&&typeof input["key"]==="string"&&((__w_0=input["clickEventUrl"])===undefined||(typeof __w_0==="string"))&&((__w_1=input["pageViewUrl"])===undefined||(typeof __w_1==="string"))&&((__w_2=input["url"])===undefined||(typeof __w_2==="string"))&&((__w_3=input["type"])===undefined||((__w_3==="page-view"||__w_3==="cta-click")))&&((__w_4=input["targets"])===undefined||(Array.isArray(__w_4)&&__af_10(__w_4)));}
var __bf_12={};
function __rf_25(o){var __rk_23,__rv_24;for(__rk_23 in o){if(__rk_23==="__proto__")continue;if(__lh_9.call(o,__rk_23)){__rv_24=o[__rk_23];if(!(typeof __rv_24==="string")){return false;}}}return true;}
function __vb_13(input){var __bv_14,__bv_15,__bv_16,__bv_17,__bv_18,__bv_19,__ba_20,__bi_21,__be_22,__bs_26,__bw_27,__bo_28;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_12;__bv_14=input["key"];if(!(typeof __bv_14==="string"))return __bf_12;__bv_15=input["clickEventUrl"];if(!((__bv_15===undefined||(typeof __bv_15==="string"))))return __bf_12;__bv_16=input["pageViewUrl"];if(!((__bv_16===undefined||(typeof __bv_16==="string"))))return __bf_12;__bv_17=input["url"];if(!((__bv_17===undefined||(typeof __bv_17==="string"))))return __bf_12;__bv_18=input["type"];if(!((__bv_18===undefined||((__bv_18==="page-view"||__bv_18==="cta-click")))))return __bf_12;__bv_19=input["targets"];if(__bv_19===undefined){__bw_27=undefined;}else{if(!Array.isArray(__bv_19))return __bf_12;__ba_20=new Array(__bv_19.length);for(__bi_21=0;__bi_21<__bv_19.length;__bi_21++){__be_22=__bv_19[__bi_21];if(!(__zcPlain(__be_22)&&__rf_25(__be_22)))return __bf_12;__bs_26=__zcPs(__be_22);__ba_20[__bi_21]=__bs_26;}__bw_27=__ba_20;}__bo_28={"key":__bv_14};if(__bv_15!==undefined||("clickEventUrl" in input)){__bo_28["clickEventUrl"]=__bv_15;}if(__bv_16!==undefined||("pageViewUrl" in input)){__bo_28["pageViewUrl"]=__bv_16;}if(__bv_17!==undefined||("url" in input)){__bo_28["url"]=__bv_17;}if(__bv_18!==undefined||("type" in input)){__bo_28["type"]=__bv_18;}if(__bw_27!==undefined||("targets" in input)){__bo_28["targets"]=__bw_27;}return __bo_28;}
var __rfm_z=__zs.safeParse;
function safeParse_VendorPixelSchema(input){
var __bd_29=__vb_13(input);
if(__bd_29!==__bf_12){return{success:true,data:__bd_29};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_VendorPixelSchema,__zs,null,__fc_11);
})()

export type VendorPixel = z.infer<typeof VendorPixelSchema>
